define([
    'modules/common/controls/select2',
    'appcontext'
], (Select2, appContext) => {

    function isRu () {
        return appContext.user().get('locale') === 'ru';
    }

    function formatState (state, localeDependent) {
        const nameKey = localeDependent ? `name_${isRu() ? 'ru' : 'en'}` : 'name';
        return '#{0} {1}'.format(state.id, _.escape(state[nameKey]));
    }

    function nameMatch (option, pattern, name) {
        return _.has(option, name) && option[name].toUpperCase().indexOf(pattern) >= 0;
    }

    return Select2.extend({

        defaults: _.extend({
            localeDependent: true
        }, Select2.prototype.defaults),

        formatSelection (state) {
            return formatState(state, this.options.localeDependent);
        },

        formatResult (state) {
            return formatState(state, this.options.localeDependent);
        },

        matcher (term, text, option) {
            const pattern = term.toUpperCase();
            const nameMatcher = _.partial(nameMatch, option, pattern);

            return nameMatcher('name') || nameMatcher('name_ru') || nameMatcher('name_en') ||
                `${option.id}`.toUpperCase().indexOf(pattern) >= 0;
        }
    });

});
